import permissions from "app/permissions";

// the backend handler requires one of these — a preview-only role passes auth but gets 403,
// so the menu item, the routes and the manage actions are hidden for it altogether
export const outgoingStudentsPermissions = [
  permissions.canManageOutgoingStudentsCoordinator,
  permissions.canManageOutgoingStudentsDean,
  permissions.canManageOutgoingStudentsRector,
];
